import React from 'react';
import RootNavigation from '../RootNavigation';

const RootNavigationContainer = () => {
  return <RootNavigation />;
};

export default RootNavigationContainer;
